import React, { useState } from 'react';
import NavBar2 from '../components/Navbar/NavBar2';
import Tos from '../components/Tos';
import Footer from '../components/Footer';

import {useDocTitle} from '../components/CustomHook';


const TosPage = () => {
    useDocTitle('Terms Of Service')

    return (
        <div className='tos'>  
          <NavBar2 />
          <Tos />
          <Footer />
        </div>


    )
}

export default TosPage;